import React, { useEffect, useState } from 'react'
import { FormControl, FormLabel, Select, Spinner } from '@chakra-ui/react'
import { getCategories } from '../../api/getNomenclatures'
import { LABEL } from '../../../../constants'

const CategoryDropDown = ({ value, onChange }) => {
  const [Categorys, setCategorys] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getCategories()
      .then((response) => {
        setCategorys(response)
        setLoading(false)
      })
      .catch((error) => {
        console.error('Eroare la preluarea datelor:', error)
        setLoading(false)
      })
  }, [])

  return (
    <FormControl>
      <FormLabel textColor="gray.500" mb="0" fontSize="sm">{LABEL.CATEGORIES_DROPDOWN.label}</FormLabel>
      {loading ? (
        <Spinner size="sm" />
      ) : (
        <Select
          bg="white"
          size="sm"
          border="1px"
          borderColor="black"
          borderRadius="lg"
          value={value || ''}
          onChange={(e) => {
            onChange(e.target.value);
          }}
          placeholder={LABEL.CATEGORIES_DROPDOWN.placeholder}
        >
          {Categorys.map((point, index) => (
            <option key={index} value={point}>
              {point}
            </option>
          ))}
        </Select>
      )}
    </FormControl>
  )
}

export default CategoryDropDown
